export default "__VITE_ASSET__C5HKZa3S__"